import { Link } from "react-router-dom";

function Home() {
  return (
    <>
    <main class="flex-shrink-0">
      <div class="container">
        <h1 class="mt-5">1001G+: The Resource</h1>
        <p class="lead">
          A central collection of 500+ assemblies and their annotations.
        </p>
        <p>
          We provide several tools to access and download the data:
        </p>
        <ul>
          <li>
            <Link to={`/accessions`}>Accessions</Link>: 
              searchable list of all assemblies and links to JBrowses.
          </li>
          <li>
            <Link to={`/graph`}>Graph</Link>: 
              Link to graph browser and download of graph based data.
          </li>
          <li>
            <Link to={`/pangenome`}>Pangenome</Link>: 
              Link to Pangenome Browser, maximum consensus sequence, and 
              annotation in pangenome coordinate context.
          </li>
          <li>
            <Link to={`/diamond`}>Diamond</Link>: 
              App for sequence similarity search.</li>
          <li>
            <Link to={`/sequences`}>Sequences</Link>: 
              App for sequence extraction by region (e.g. 
              Chr1:12000..15000).
          </li>
          <li>
            <Link to={`/variants`}>Variants</Link>: 
              Variant browser app.
          </li>
          
          <li>
            <Link to={`/map`}>Map</Link>: 
              A simple Open Street Map with markers on it.
          </li>
        </ul>
      </div>
    </main>
    </>
  );
}

export default Home;
